import translationKeys from '@translationKeys'

import { colors } from '@theme/variables'

import { ActionType, MeetingStatus } from './types'

export const MEETING_STATUS_TO_COLOR_MAP = {
  [MeetingStatus.NO_RESPONSE]: {
    text: '#3A6DF2',
    bar: '#3A6DF2',
  },
  [MeetingStatus.UPCOMING]: {
    text: '#2A826D',
    bar: '#60CCB2',
  },
  [MeetingStatus.PAST]: {
    text: '#347B9F',
    bar: '#3EABE3',
  },
  [MeetingStatus.PENDING]: {
    text: '#996E2D',
    bar: '#FF8E0A',
  },
  [MeetingStatus.CANCELED]: {
    text: '#CD4836',
    bar: '#F96060',
  },
  [MeetingStatus.DECLINED]: {
    text: '#CD4836',
    bar: '#F96060',
  },

  [MeetingStatus.INMAIL]: {
    text: '#AF39E7',
    bar: '#AF39E7',
  },

  /** BELOW TWO ARE TEMP UNTIL BE IS FIXED */
  [MeetingStatus.SCHEDULED]: {
    text: '#2A826D',
    bar: '#60CCB2',
  },
  [MeetingStatus.RESCHEDULED]: {
    text: '#2A826D',
    bar: '#60CCB2',
  },

  x: {
    text: 'transparent',
    bar: 'transparent',
  },
}

export const MEETING_STATUS_COUNTS_TO_LABEL_MAP = {
  [MeetingStatus.UPCOMING]: translationKeys.MEETING_UPCOMING_STATUS,
  [MeetingStatus.SCHEDULED]: translationKeys.MEETING_UPCOMING_STATUS,
  [MeetingStatus.RESCHEDULED]: translationKeys.MEETING_UPCOMING_STATUS,
  [MeetingStatus.NO_RESPONSE]: translationKeys.MEETING_NO_RESPONSE_STATUS_COUNT,

  [MeetingStatus.PAST]: translationKeys.MEETING_PAST_STATUS_COUNT,
  [MeetingStatus.PENDING]: translationKeys.MEETING_PENDING_STATUS_COUNT,
  [MeetingStatus.CANCELED]: translationKeys.MEETING_CANCELED_STATUS,
  [MeetingStatus.DECLINED]: translationKeys.MEETING_DECLINED_STATUS,
  [MeetingStatus.INMAIL]: translationKeys.MEETING_INMAIL_STATUS_COUNT,
}
export const MEETING_STATUS_TO_LABEL_MAP = {
  ...MEETING_STATUS_COUNTS_TO_LABEL_MAP,
  [MeetingStatus.PENDING]: translationKeys.MEETING_PENDING_STATUS,
  [MeetingStatus.PAST]: translationKeys.MEETING_PAST_STATUS,
  [MeetingStatus.NO_RESPONSE]: translationKeys.MEETING_NO_RESPONSE_STATUS,
}

export const MEETING_STATUS_ORDER = [
  MeetingStatus.UPCOMING,
  MeetingStatus.SCHEDULED,
  MeetingStatus.RESCHEDULED,

  MeetingStatus.PENDING,
  MeetingStatus.PAST,
  MeetingStatus.INMAIL,
  MeetingStatus.NO_RESPONSE,
  MeetingStatus.CANCELED,
  MeetingStatus.DECLINED,
]

export const VISIBLE_DAYS_AMOUNT = 10

export const ACTION_TYPE_TO_STATUS_COLORS_MAP: Record<string, { border: string; background: string }> = {
  [ActionType.ACTION_CREATE]: colors.messages.accepted,
  [ActionType.ACTION_CANCEL]: colors.messages.canceled,
  [ActionType.ACTION_UPDATE]: colors.messages.canceled,
  [ActionType.ACTION_LOCATION_UPDATE]: colors.messages.canceled,
  [ActionType.ACTION_ACCEPT]: colors.messages.accepted,
  [ActionType.ACTION_DELETE]: colors.messages.canceled,
  [ActionType.ACTION_DECLINE]: colors.messages.canceled,
  [ActionType.ACTION_REACTIVATE]: colors.messages.reactivate,
  [ActionType.ACTION_MISSING_AVAILABILITY]: colors.messages.missingAvailability,
  [ActionType.ACTION_SCHEDULE]: colors.messages.rescheduling,
  [ActionType.ACTION_RESCHEDULE_REQUEST]: colors.messages.accepted,
  [ActionType.ACTION_RESCHEDULE]: colors.messages.rescheduling,
}

export const ACTION_TYPE_TO_STATUS_LABEL_MAP: Record<string, string> = {
  [ActionType.ACTION_CREATE]: 'Meeting requested',
  [ActionType.ACTION_CANCEL]: 'Meeting canceled',
  [ActionType.ACTION_UPDATE]: 'Meeting updated',
  [ActionType.ACTION_LOCATION_UPDATE]: 'Location updated',
  [ActionType.ACTION_ACCEPT]: 'Request accepted',
  [ActionType.ACTION_DELETE]: 'Meeting deleted',
  [ActionType.ACTION_DECLINE]: 'Request declined',
  [ActionType.ACTION_REACTIVATE]: 'Request reactivated',
  [ActionType.ACTION_MISSING_AVAILABILITY]: 'Missing availability',
  [ActionType.ACTION_SCHEDULE]: 'Meeting scheduled',
  [ActionType.ACTION_RESCHEDULE_REQUEST]: 'Rescheduling requested',
  [ActionType.ACTION_RESCHEDULE]: 'Meeting rescheduled',
}
